import { Model } from 'modules/core/lib/mobx-rest'

interface IPayrollDocument {
  id: string
  payroll_policy_period_id: string
  document_id: string
}

class PayrollDocument extends Model<IPayrollDocument> {
  static urlRoot() {
    return '/payroll/payroll_documents'
  }
}

export default PayrollDocument
